import { ReactNode } from "react";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface WidgetProperties {
  children?: ReactNode;
  additionalClassNames?: string | null;
}

interface WidgetHeaderProperties {
  children?: ReactNode;
  title: string;
  titleIcon?: string | null;
  titleBackgroundColor?: WidgetTitleBackgroundColor | null;
}

interface WidgetIcon {
  Critical: string,
  Info: string,
  Warning: string
}

const WidgetIconImpl: WidgetIcon = {
  Critical: QesIcons.AlertHexagon,
  Info: QesIcons.InfoCircle,
  Warning: QesIcons.AlertTriangle,
}

enum WidgetTitleIconColor {
  Blue = "ni-title-icon-blue",
  Red = "ni-title-icon-red",
  Yellow = "ni-title-icon-yellow"
}

enum WidgetTitleBackgroundColor {
  Red = "ni-title-bg-red",
  Yellow = "ni-title-bg-yellow",
}

export {
  WidgetHeaderProperties,
  WidgetIconImpl as WidgetIcon,
  WidgetProperties,
  WidgetTitleIconColor,
  WidgetTitleBackgroundColor
}